import { progressBar } from '../stepper/stepper-functions';

$(function() {
    let $quizForm = $('#quizQuestions');
    let $stepperGroups = $('.stepper-groups');
    let $groupButton = $('.group-button');
    let $groupCheckbox = $('.group-checkbox');
    let $next = $('.next');
    let $prev = $('.prev');
    let $currentGroup = '';
    let groupsCount = $stepperGroups.children('.jq-group').size();
    let groupCurrent = 0;
    let selectGroup = '';
    let stepCurrent = 0;
    let stepsCount = 0;
    let nextBtnStatus = false;

    const buttons = {
        nextShow: function () {
            $next.removeClass('disabled');
            $next.removeAttr('disabled');
            nextBtnStatus = true;
        },
        nextHide: function () {
            $next.addClass('disabled');
            $next.attr('disabled', true);
            nextBtnStatus = false;
        },
        prevShow: function () {
            $prev.removeClass('disabled');
            $prev.removeAttr('disabled');
        },
        prevHide: function () {
            $prev.addClass('disabled');
            $prev.attr('disabled', true);
        },
    };

    $(document).ready(function () {

        // let button = '<button class="btn accent_red skip-question">Skip</button>';

        // $(button).insertAfter( ".jq-group.group1 .jq-step.step4 .jq-step-content" );
        // $(button).insertAfter( ".jq-group.group1 .jq-step.step5 .jq-step-content" );
        // $(button).insertAfter( ".jq-group.group2 .jq-step.step2 .jq-step-content" );
        // $(button).insertAfter( ".jq-group.group2 .jq-step.step3 .jq-step-content" );
        // $(button).insertAfter( ".jq-group.group3 .jq-step.step4 .jq-step-content" );
        // $(button).insertAfter( ".jq-group.group3 .jq-step.step5 .jq-step-content" );
        // $(button).insertAfter( ".jq-group.group3 .jq-step.step6 .jq-step-content" );

        // $( ".skip-question" ).click(function(evt) {
        //     evt.preventDefault();
        //     let parentDiv = $(this).parent();
        //     parentDiv.find("label").first().trigger("click");
        //     $('.btn.accent_red.next').trigger("click");
           
        //   });

        if($quizForm.length) {
            progressBar.init($quizForm, stepsCount, stepCurrent);
        }
        $('.stepper').children('.stepper-groups').find('input[type="text"]').inputmask({
            alias: 'decimal',
            rightAlign: false,
            groupSeparator: '.',
            autoGroup: true,
        });
        $(document).on('keypress', function(e) {
            if(e.which === 13 && nextBtnStatus) {
                e.preventDefault();
                if($('.stepper-footer').children('.next').length !== 0) {
                    console.log('Next');
                    nextStep($next);
                } else {
                    console.log('Hello');
                }
            }
        });

        $next.on('click', function (e) {
            e.preventDefault();
            nextStep($(this));
        });

        function nextStep($this) {
            selectGroup = $groupButton.children('.group:checked').attr('data-group');
            stepsCount = $stepperGroups.children('.' + selectGroup).children('.jq-step').size();
            $currentGroup = $('.'+selectGroup);
            if(groupCurrent >= 0 && groupCurrent !== groupsCount && stepCurrent !== stepsCount) {
                groupCurrent = groupCurrent + 1;
                $stepperGroups.children('.jq-group').addClass('d-none');
                $stepperGroups.children('.' + selectGroup).removeClass('d-none');
            }
            if(groupCurrent >= 0 && stepCurrent >= 0 && stepCurrent !== stepsCount) {
                stepCurrent = stepCurrent + 1;
                progressBar.init($quizForm, stepsCount, stepCurrent);
                $stepperGroups.children('.' + selectGroup).children('.jq-step').addClass('d-none');
                $stepperGroups.children('.' + selectGroup).children('.step' + stepCurrent).removeClass('d-none');
            } else {
                $('#quizQuestions').submit();
            }
            if($currentGroup.children('.step'+stepCurrent).find('input[type="radio"]').is(':checked')) {
                buttons.nextShow();
            } else {
                buttons.nextHide();
            }
            if($currentGroup.children('.step'+stepCurrent).find('input[type="text"]').length > 0) {
                if($currentGroup.children('.step'+stepCurrent).find('input[type="text"]').val() !== '') {
                    buttons.nextShow();
                } else {
                    buttons.nextHide();
                }
            }
            $currentGroup.children('.step'+stepCurrent).find('input[type="text"]').keyup(function() {
                if ($(this).val() !== '') {
                    buttons.nextShow();
                } else {
                    buttons.nextHide();
                }
            });
            if($currentGroup.children('.step'+stepCurrent).find('input[type="number"]').length > 0) {
                if($currentGroup.children('.step'+stepCurrent).find('input[type="number"]').attr('required')) {
                    if ($currentGroup.children('.step'+stepCurrent).find('input[type="number"]').val() !== '') {
                        buttons.nextShow();
                    } else {
                        buttons.nextHide();
                    }
                }
            }
            $currentGroup.children('.step'+stepCurrent).find('input[type="number"]').keyup(function () {
                if($(this).attr('required')) {
                    if($(this).val() !== '') {
                        buttons.nextShow();
                    } else {
                        buttons.nextHide();
                    }
                }
            });
        
        }

        $prev.on('click', function (e) {
            e.preventDefault();
            selectGroup = $groupButton.children('.group:checked').attr('data-group');
            stepsCount = $stepperGroups.children('.' + selectGroup).children('.jq-step').size();
            if(groupCurrent <= groupsCount && groupCurrent !== 0) {
                groupCurrent = groupCurrent - 1;
                $stepperGroups.children('.jq-group').addClass('d-none');
                $stepperGroups.children('.' + selectGroup).addClass('d-none');
            }
            if(groupCurrent <= groupsCount && stepCurrent !== 0) {
                stepCurrent = stepCurrent - 1;
                progressBar.init($quizForm, stepsCount, stepCurrent);
                $stepperGroups.children('.' + selectGroup).removeClass('d-none');
                $stepperGroups.children('.' + selectGroup).children('.jq-step').addClass('d-none');
                $stepperGroups.children('.' + selectGroup).children('.step' + stepCurrent).removeClass('d-none');
            }
            if($currentGroup.children('.step'+stepCurrent).find('input[type="radio"]').is(':checked')) {
                buttons.nextShow();
            } else {
                buttons.nextHide();
            }
            if(stepCurrent !== stepsCount) {
                buttons.nextShow();
            }
            if(stepCurrent === 0) {
                $stepperGroups.children('.jq-group').addClass('d-none');
                $stepperGroups.children('.first-screen').removeClass('d-none');
                resetQuizFieldsVal($('#quizQuestions'));
                $('#quizQuestions')[0].reset();
            } else {
                if($('input[type="radio"][name="'+selectGroup+'step'+stepCurrent+'"]').is(':checked')) {
                    buttons.nextShow();
                } else {
                    buttons.nextHide();
                }
            }
        });

        $groupCheckbox.on('click', function (e) {
            e.preventDefault();
            //$(this).parent().children('.group-button').removeClass('active');
            if(!$(this).hasClass('active')) {
                $(this).addClass('active');
                $(this).children('input[type="checkbox"]').prop('checked', true);
            } else {
                $(this).removeClass('active');
                $(this).children('input[type="checkbox"]').prop('checked', false);
            }
            if($('input[type="radio"][class="group"]').is(':checked')) {
                nextBtnStatus = true;
                $('.next').removeClass('disabled');
                $('.next').removeAttr('disabled');
            }
        });

        $groupButton.on('click', function (e) {
            e.preventDefault();
            $(this).parent().children('.group-button').removeClass('active');
            if(!$(this).hasClass('active')) {
                $(this).addClass('active');
                $(this).children('input[type="radio"]').prop('checked', true);
            } else {
                $(this).removeClass('active');
                $(this).children('input[type="radio"]').prop('checked', false);
            }
            if($('input[type="radio"][class="group"]').is(':checked')) {
                nextBtnStatus = true;
                $('.next').removeClass('disabled');
                $('.next').removeAttr('disabled');
            }
        });

        $('#quizQuestions').on('submit', function (e) {
            e.preventDefault();
            let form = $(this)[0];
            let url = $(this).attr('data-url'),
                type = $(this).attr('method'),
                formData = new FormData(form);
            $.ajax({
                url: url,
                data: formData,
                type: type,
                contentType: false,
                processData: false,
            }).done(function (res) {
                let response = JSON.parse(res);
                if(Object.keys(response.data).length !== 0) {
                    localStorage.setItem('preloader', 'true');
                    let params = (new URL(document.location)).searchParams;
                    window.location.href = '/accountants/?post_code=' + params.get('post_code');
                }
            }).fail(function (error) {
                alert(error);
            });
        });

        function resetQuizFieldsVal($form) {
            $form.find('input[type="text"]').each(function() {
                $(this).val('');
            });
            $form.find('input[type="number"]').each(function() {
                $(this).val('');
            });
            $form.find('input[type="radio"]').each(function () {
                $(this).parent('.group-button').removeClass('active');
                $(this).prop('checked', false);
            });
            buttons.nextHide();
        }
    });
});


// WEBPACK FOOTER //
// ./scripts/routes/quiz-questions.js